module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card-content', {
    key: _vm.handler,
    staticClass: "ql-cue-body",
    style: (_vm.style())
  }, [(_vm.localCue.data) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "flex-row"
  }, [_c('md-input-container', {
    staticClass: "field-label"
  }, [_c('label', {
    attrs: {
      "for": "label"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.label,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.label', e); }
    }
  })], 1), _vm._v(" "), (!_vm.locked && !_vm.editing && _vm.editable) ? _c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.destroy
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Delete Cue")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('description')) ? _c('md-input-container', {
    staticClass: "field-description"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.description,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.description', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('parts')) ? _c('md-input-container', {
    staticClass: "field-parts"
  }, [_c('label', {
    attrs: {
      "for": "parts"
    }
  }, [_vm._v("Parts")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localCue.data.parts),
      expression: "localCue.data.parts"
    }],
    staticClass: "custom-select",
    staticStyle: {
      "width": "42px"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.localCue.data, "parts", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.partsChanged]
    }
  }, _vm._l((['', 2, 3, 4, 5, 6, 7, 8]), function(part, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": part
      }
    }, [_vm._v(_vm._s(part))])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.localCue.data.parts) ? _c('div', {
    staticClass: "flex-row flex-column"
  }, _vm._l((_vm.localCue.data.partsData), function(partData) {
    return _c('div', {
      key: _vm.getPartIndex(partData),
      staticClass: "field-parts-data flex-row flex-column"
    }, [_c('div', {
      staticClass: "flex-row"
    }, [_c('md-input-container', {
      staticClass: "field-part"
    }, [_c('label', {
      attrs: {
        "for": "part"
      }
    }, [_vm._v("P")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }
      },
      model: {
        value: (partData.id),
        callback: function($$v) {
          _vm.$set(partData, "id", $$v)
        },
        expression: "partData.id"
      }
    })], 1), _vm._v(" "), (_vm.isAvailable('label')) ? _c('md-input-container', {
      staticClass: "field-part-label"
    }, [_c('label', {
      attrs: {
        "for": "part-label"
      }
    }, [_vm._v("Label")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }
      },
      model: {
        value: (partData.label),
        callback: function($$v) {
          _vm.$set(partData, "label", $$v)
        },
        expression: "partData.label"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-row"
    }, [(_vm.isAvailable('time')) ? _c('md-input-container', {
      staticClass: "field-time"
    }, [_c('label', {
      attrs: {
        "for": "time"
      }
    }, [_vm._v("Time")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }
      },
      model: {
        value: (partData.time),
        callback: function($$v) {
          _vm.$set(partData, "time", $$v)
        },
        expression: "partData.time"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('focus')) ? _c('md-input-container', {
      staticClass: "field-focus"
    }, [_c('label', {
      attrs: {
        "for": "focus"
      }
    }, [_vm._v("Focus")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }
      },
      model: {
        value: (partData.focus),
        callback: function($$v) {
          _vm.$set(partData, "focus", $$v)
        },
        expression: "partData.focus"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('color')) ? _c('md-input-container', {
      staticClass: "field-color"
    }, [_c('label', {
      attrs: {
        "for": "color"
      }
    }, [_vm._v("Color")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }
      },
      model: {
        value: (partData.color),
        callback: function($$v) {
          _vm.$set(partData, "color", $$v)
        },
        expression: "partData.color"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('beam')) ? _c('md-input-container', {
      staticClass: "field-beam"
    }, [_c('label', {
      attrs: {
        "for": "beam"
      }
    }, [_vm._v("Beam")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "readonly": !_vm.editable
      },
      on: {
        "blur": function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }
      },
      model: {
        value: (partData.beam),
        callback: function($$v) {
          _vm.$set(partData, "beam", $$v)
        },
        expression: "partData.beam"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('mark')) ? _c('md-input-container', {
      staticClass: "field-mark"
    }, [_c('label', {
      attrs: {
        "for": "mark"
      }
    }, [_vm._v("M")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (partData.mark),
        expression: "partData.mark"
      }],
      staticClass: "custom-select",
      staticStyle: {
        "width": "42px"
      },
      attrs: {
        "disabled": !_vm.editable
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(partData, "mark", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.modifyCue("data.partsData", _vm.localCue.data.partsData)
        }]
      }
    }, _vm._l((['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']), function(mark, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": mark
        }
      }, [_vm._v(_vm._s(mark))])
    }), 0)]) : _vm._e()], 1)])
  }), 0) : _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('time')) ? _c('md-input-container', {
    staticClass: "field-time"
  }, [_c('label', {
    attrs: {
      "for": "time"
    }
  }, [_vm._v("Time")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.time,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.time', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('focus')) ? _c('md-input-container', {
    staticClass: "field-focus"
  }, [_c('label', {
    attrs: {
      "for": "focus"
    }
  }, [_vm._v("Focus")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.focus,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.focus', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('color')) ? _c('md-input-container', {
    staticClass: "field-color"
  }, [_c('label', {
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.color,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.color', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('beam')) ? _c('md-input-container', {
    staticClass: "field-beam"
  }, [_c('label', {
    attrs: {
      "for": "beam"
    }
  }, [_vm._v("Beam")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.beam,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.beam', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('mark')) ? _c('md-input-container', {
    staticClass: "field-mark",
    class: {
      'md-has-value': _vm.localCue.data.mark
    }
  }, [_c('label', {
    attrs: {
      "for": "mark"
    }
  }, [_vm._v("M")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.mark
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.mark', e.target.value); }
    }
  }, _vm._l((['', 'M', 'Mh', 'Ml', 'D', 'R', '+', 'x']), function(mark, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": mark
      }
    }, [_vm._v(_vm._s(mark))])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('duration')) ? _c('md-input-container', {
    staticClass: "field-duration"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Duration")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.duration,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.duration', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('followHang')) ? _c('md-input-container', {
    staticClass: "field-follow-hang-type",
    class: {
      'md-has-value': _vm.localCue.data.followHangType
    }
  }, [_c('label', {
    attrs: {
      "for": "follow-hang-type"
    }
  }, [_vm._v("F/H")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.followHangType
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.followHangType', e.target.value); }
    }
  }, _vm._l((['', 'F', 'H']), function(fh, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": fh
      }
    }, [_vm._v(_vm._s(fh))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAvailable('followHang')) ? _c('md-input-container', {
    staticClass: "field-follow-hang"
  }, [_c('label', {
    attrs: {
      "for": "follow-hang"
    }
  }, [_vm._v("Fw/Hg Time")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.followHang,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.followHang', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('block')) ? _c('md-input-container', {
    staticClass: "field-block",
    class: {
      'md-has-value': _vm.localCue.data.block
    }
  }, [_c('label', {
    attrs: {
      "for": "block"
    }
  }, [_vm._v("Block")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.block
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.block', e.target.value); }
    }
  }, _vm._l((['', 'B', 'I', 'b']), function(block, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": block
      }
    }, [_vm._v(_vm._s(block))])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('assert')) ? _c('md-input-container', {
    staticClass: "field-assert",
    class: {
      'md-has-value': _vm.localCue.data.assert
    }
  }, [_c('label', {
    attrs: {
      "for": "assert"
    }
  }, [_vm._v("Assert")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.assert
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.assert', e.target.value); }
    }
  }, _vm._l((['', 'A', 'a']), function(assert, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": assert
      }
    }, [_vm._v(_vm._s(assert))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAvailable('link')) ? _c('md-input-container', {
    staticClass: "field-link"
  }, [_c('label', {
    attrs: {
      "for": "link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.link,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.link', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('loop')) ? _c('md-input-container', {
    staticClass: "field-loop"
  }, [_c('label', {
    attrs: {
      "for": "loop"
    }
  }, [_vm._v("Loop")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.loop,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.loop', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('curve')) ? _c('md-input-container', {
    staticClass: "field-curve"
  }, [_c('label', {
    attrs: {
      "for": "curve"
    }
  }, [_vm._v("Curve")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.curve,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.curve', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('externalLinks')) ? _c('md-input-container', {
    staticClass: "field-external-links"
  }, [_c('label', {
    attrs: {
      "for": "external-links"
    }
  }, [_vm._v("Ext Links")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.externalLinks,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.externalLinks', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('notes')) ? _c('md-input-container', {
    staticClass: "field-notes"
  }, [_c('label', {
    attrs: {
      "for": "notes"
    }
  }, [_vm._v("Notes")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.notes,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.notes', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('target')) ? _c('md-input-container', {
    staticClass: "field-target"
  }, [_c('label', {
    attrs: {
      "for": "target"
    }
  }, [_vm._v("Target")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.target,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.target', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('preWait')) ? _c('md-input-container', {
    staticClass: "field-preWait"
  }, [_c('label', {
    attrs: {
      "for": "pre-wait"
    }
  }, [_vm._v("Pre Wait")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.preWait,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.preWait', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('action')) ? _c('md-input-container', {
    staticClass: "field-action"
  }, [_c('label', {
    attrs: {
      "for": "action"
    }
  }, [_vm._v("Action")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.action,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.action', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('postWait')) ? _c('md-input-container', {
    staticClass: "field-postWait"
  }, [_c('label', {
    attrs: {
      "for": "post-wait"
    }
  }, [_vm._v("Post Wait")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.postWait,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.postWait', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('placement')) ? _c('md-input-container', {
    staticClass: "field-placement"
  }, [_c('label', {
    attrs: {
      "for": "placement"
    }
  }, [_vm._v("Placement")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.placement,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.placement', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('purpose')) ? _c('md-input-container', {
    staticClass: "field-purpose"
  }, [_c('label', {
    attrs: {
      "for": "purpose"
    }
  }, [_vm._v("Purpose")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.purpose,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.purpose', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('followMode')) ? _c('md-input-container', {
    staticClass: "field-followMode"
  }, [_c('label', {
    attrs: {
      "for": "follow-mode"
    }
  }, [_vm._v("Follow Mode")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.followMode,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.followMode', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('routing')) ? _c('md-input-container', {
    staticClass: "field-routing"
  }, [_c('label', {
    attrs: {
      "for": "routing"
    }
  }, [_vm._v("Routing")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.routing,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.routing', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('trigger')) ? _c('md-input-container', {
    staticClass: "field-trigger"
  }, [_c('label', {
    attrs: {
      "for": "trigger"
    }
  }, [_vm._v("Trigger")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.trigger,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.trigger', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('propName')) ? _c('md-input-container', {
    staticClass: "field-propName"
  }, [_c('label', {
    attrs: {
      "for": "prop-name"
    }
  }, [_vm._v("Prop Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.propName,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.propName', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('propQuantity')) ? _c('md-input-container', {
    staticClass: "field-propQuantity"
  }, [_c('label', {
    attrs: {
      "for": "prop-quantity"
    }
  }, [_vm._v("Prop Quantity")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.propQuantity,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.propQuantity', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('preset')) ? _c('md-input-container', {
    staticClass: "field-preset"
  }, [_c('label', {
    attrs: {
      "for": "preset"
    }
  }, [_vm._v("Preset")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.preset,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.preset', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('whoEnter')) ? _c('md-input-container', {
    staticClass: "field-whoEnter ds"
  }, [_c('label', {
    attrs: {
      "for": "who-enter"
    }
  }, [_vm._v("Who Enter")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.whoEnter,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.whoEnter', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('whereEnter')) ? _c('md-input-container', {
    staticClass: "field-whereEnter"
  }, [_c('label', {
    attrs: {
      "for": "where-enter"
    }
  }, [_vm._v("Where Enter")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.whereEnter,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.whereEnter', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('whoExit')) ? _c('md-input-container', {
    staticClass: "field-whoExit"
  }, [_c('label', {
    attrs: {
      "for": "who-exit"
    }
  }, [_vm._v("Who Exit")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.whoExit,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.whoExit', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('whereExit')) ? _c('md-input-container', {
    staticClass: "field-whereExit"
  }, [_c('label', {
    attrs: {
      "for": "where-exit"
    }
  }, [_vm._v("Where Exit")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.whereExit,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.whereExit', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('exitPage')) ? _c('md-input-container', {
    staticClass: "field-exitPage"
  }, [_c('label', {
    attrs: {
      "for": "exit-page"
    }
  }, [_vm._v("Exit Page")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.exitPage,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.exitPage', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.userDefined), function(attr, index) {
    return _c('div', {
      key: index,
      staticClass: "flex-row"
    }, [(attr.value === true) ? _c('md-input-container', {
      staticClass: "field-userDefined"
    }, [(attr.label) ? _c('label', {
      attrs: {
        "for": "user-defined"
      }
    }, [_vm._v(_vm._s(attr.label))]) : _c('label', {
      attrs: {
        "for": "user-defined"
      }
    }, [_vm._v("User " + _vm._s(index.replaceAll(/\D+/g, '')))]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": _vm.localCue.data[index],
        "readonly": !_vm.editable
      },
      on: {
        "blur": function (e) { return _vm.modifyCue(("data." + index), e); }
      }
    })], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('propNotes')) ? _c('md-input-container', {
    staticClass: "field-propNotes"
  }, [_c('label', {
    attrs: {
      "for": "prop-notes"
    }
  }, [_vm._v("Prop Notes")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.propNotes,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.propNotes', e); }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAvailable('consumable')) ? _c('md-input-container', {
    staticClass: "field-consumable"
  }, [_c('label', {
    attrs: {
      "for": "consumable"
    }
  }, [_vm._v("Consumable")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "62px"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.consumable
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.consumable', e.target.value); }
    }
  }, _vm._l((['N', 'Y']), function(consumable, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": consumable
      }
    }, [_vm._v(_vm._s(consumable))])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('rehearsal')) ? _c('md-input-container', {
    staticClass: "field-rehearsal"
  }, [_c('label', {
    attrs: {
      "for": "rehearsal"
    }
  }, [_vm._v("Rehearsal")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "42px"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.rehearsal
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.rehearsal', e.target.value); }
    }
  }, _vm._l((['N', 'Y']), function(rehearsal, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": rehearsal
      }
    }, [_vm._v(_vm._s(rehearsal))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAvailable('rehearsalSource')) ? _c('md-input-container', {
    staticClass: "field-rehearsalSource"
  }, [_c('label', {
    attrs: {
      "for": "rehearsal-source"
    }
  }, [_vm._v("Rehearsal Source")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.rehearsalSource,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.rehearsalSource', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row"
  }, [(_vm.isAvailable('actual')) ? _c('md-input-container', {
    staticClass: "field-actual"
  }, [_c('label', {
    attrs: {
      "for": "actual"
    }
  }, [_vm._v("Actual")]), _vm._v(" "), _c('select', {
    staticClass: "custom-select",
    staticStyle: {
      "width": "42px"
    },
    attrs: {
      "disabled": !_vm.editable
    },
    domProps: {
      "value": _vm.localCue.data.actual
    },
    on: {
      "change": function (e) { return _vm.modifyCue('data.actual', e.target.value); }
    }
  }, _vm._l((['N', 'Y']), function(actual, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": actual
      }
    }, [_vm._v(_vm._s(actual))])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAvailable('actualSource')) ? _c('md-input-container', {
    staticClass: "field-actualSource"
  }, [_c('label', {
    attrs: {
      "for": "actual-source"
    }
  }, [_vm._v("Actual Source")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.localCue.data.actualSource,
      "readonly": !_vm.editable
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.actualSource', e); }
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-row",
    class: {
      'work-note-row--noteslist-locked': _vm.notesListLinked
    }
  }, [_c('md-input-container', {
    staticClass: "field-label"
  }, [_c('label', {
    staticClass: "cue-label",
    attrs: {
      "for": "work-note"
    }
  }, [_vm._v("Work Note")]), _vm._v(" "), _c('span', {
    staticClass: "work-note-control-wrap"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense btn-mark-workNote",
    class: {
      'workNote-marked': _vm.activeWorkNote
    },
    attrs: {
      "disabled": _vm.notesListLinked || !_vm.editable
    },
    on: {
      "click": _vm.toggleWorkNote
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.localCue.data.workNote || !_vm.activeWorkNote),
      expression: "!localCue.data.workNote || !activeWorkNote"
    }]
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeWorkNote),
      expression: "activeWorkNote"
    }]
  }, [_vm._v("check_box")])], 1), _vm._v(" "), (_vm.notesListLinked) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Please check note on Notes List side")]) : (!_vm.localCue.data.workNote) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Check or write text to add work note.")]) : _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Uncheck to delete note without archiving.")])], 1), _vm._v(" "), _c('span', {
    staticClass: "work-note-control-wrap work-note-input-wrap"
  }, [_c('md-input', {
    ref: "input_worknote",
    staticStyle: {
      "padding-left": "10px"
    },
    attrs: {
      "value": _vm.workingNote ? _vm.workingNote : '',
      "readonly": _vm.notesListLinked || !_vm.editable,
      "disabled": _vm.notesListLinked
    },
    on: {
      "blur": function (e) { return _vm.modifyCue('data.workNote', e); }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.toggle.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.notesListLinked) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Please check note on Notes List side")]) : _vm._e()], 1), _vm._v(" "), (_vm.editable && _vm.workingNote) ? _c('span', {
    staticClass: "work-note-control-wrap"
  }, [_c('md-button', {
    staticClass: "btn-archive-cue",
    on: {
      "click": function($event) {
        return _vm.toggleArchiveWorkNoteCue($event)
      }
    }
  }, [_c('md-icon', [_vm._v("move_to_inbox")])], 1), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Archive this work note.")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [(_vm.editable) ? _c('div', {
    staticClass: "btn-view-archived-list",
    on: {
      "click": _vm.onWorkNoteModalOpen
    }
  }, [_c('md-icon', [_vm._v("move_to_inbox")]), _vm._v("\n                View Archived Work Notes\n            ")], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-dense btn-close-button",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v("Close")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('md-dialog', {
    ref: "workNoteModal",
    staticClass: "collaborator-access-modal"
  }, [_c('md-dialog-title', {
    staticClass: "modal-header"
  }, [_vm._v("Archived Work Notes")]), _vm._v(" "), _c('md-dialog-content', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.editable && _vm.getArchivedWorkNotes.length) ? _c('md-layout', [(_vm.getArchivedWorkNotes.length === 1) ? _c('md-list-item', {
    staticClass: "worknote-item-cue",
    staticStyle: {
      "border-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "worknote-item-cue-info"
  }, [_c('div', {
    staticClass: "worknote-item-cue-info-body"
  }, [_c('div', {
    staticClass: "worknote-item-cue-info-desc"
  }, [_vm._v(_vm._s(_vm.getArchivedWorkNotes[0].note))]), _vm._v(" "), _c('div', {
    staticClass: "worknote-item-cue-info-date",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.getEditedDateTime(_vm.getArchivedWorkNotes[0])) + "\n                                "), (_vm.editable && _vm.getArchivedWorkNotes[0].archived && !_vm.notesListLinked) ? _c('md-button', {
    staticClass: "md-icon-button btn-archive-cue",
    on: {
      "click": function($event) {
        return _vm.unArchivedWorkNoteCue(_vm.getArchivedWorkNotes[0], 0, $event)
      }
    }
  }, [_c('md-icon', [_vm._v("unarchive")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Restore as the current note. Any current note on this cue is archived, not deleted.")])], 1) : _vm._e(), _vm._v(" "), (_vm.editable && _vm.getArchivedWorkNotes[0].archived) ? _c('md-button', {
    staticClass: "md-icon-button btn-archive-cue",
    on: {
      "click": function($event) {
        return _vm.removeArchivedNote(_vm.getArchivedWorkNotes[0], $event)
      }
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "left"
    }
  }, [_vm._v("Permanently delete this note.")])], 1) : _vm._e()], 1)])])]) : _vm._l((_vm.getArchivedWorkNotes), function(workNote, index) {
    return _c('md-list-item', {
      key: workNote.editedAt,
      staticClass: "worknote-item-cue"
    }, [_c('div', {
      staticClass: "worknote-item-cue-info"
    }, [_c('div', {
      staticClass: "worknote-item-cue-info-body"
    }, [_c('div', {
      staticClass: "worknote-item-cue-info-desc"
    }, [_vm._v(_vm._s(workNote.note))]), _vm._v(" "), _c('div', {
      staticClass: "worknote-item-cue-info-date",
      staticStyle: {
        "padding-top": "0px"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.getEditedDateTime(workNote)) + "\n                                    "), (_vm.editable && workNote.archived && !_vm.notesListLinked) ? _c('md-button', {
      staticClass: "md-icon-button btn-archive-cue",
      on: {
        "click": function($event) {
          return _vm.unArchivedWorkNoteCue(workNote, index, $event)
        }
      }
    }, [_c('md-icon', [_vm._v("unarchive")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "left"
      }
    }, [_vm._v("Restore as the current note. Any current note on this cue is archived, not deleted.")])], 1) : _vm._e(), _vm._v(" "), (_vm.editable && workNote.archived) ? _c('md-button', {
      staticClass: "md-icon-button btn-archive-cue",
      on: {
        "click": function($event) {
          return _vm.removeArchivedNote(workNote, index, $event)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', {
      attrs: {
        "md-direction": "left"
      }
    }, [_vm._v("Permanently delete this note.")])], 1) : _vm._e()], 1)])])])
  })], 2) : _c('md-list-item', {
    staticClass: "worknote-item-cue",
    staticStyle: {
      "border-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "worknote-item-cue-info"
  }, [_c('div', {
    staticClass: "worknote-item-cue-info-body"
  }, [_c('span', {
    staticClass: "worknote-item-cue-info-desc"
  }, [_vm._v("There are no archived notes.")])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b0a00f0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/cues/cue-body.vue
// module id = 1239
// module chunks = 21